import { useEffect, useState } from 'react'

const useFullwidthModalDetect = () => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkBreakpoint = () => {
            const fullwidthModalBreakpoint = 900

            setIsMobile(window.innerWidth < fullwidthModalBreakpoint)
        }

        checkBreakpoint()

        window.addEventListener('resize', checkBreakpoint)

        return () => {
            window.removeEventListener('resize', checkBreakpoint)
        }
    }, [])

    return isMobile
}

export default useFullwidthModalDetect
